// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/fonts/work-sans-v19-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/fonts/work-sans-v19-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/fonts/work-sans-v19-latin-700.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/fonts/lexend-tera-v28-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/fonts/lexend-tera-v28-latin-800.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* work-sans-regular - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* work-sans-500 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* work-sans-700 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lexend-tera-regular - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Lexend Tera";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* lexend-tera-800 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Lexend Tera";
  font-style: normal;
  font-weight: 800;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
:root {
  --primary: #f7f7f7;
  --primary-green: #355e3b;
  --text-2: #727272;
  --secondary: #f3b86a;
  --text-1: #484848;
  --white: #f4f4f4;
  --white-main: #fefefe;
  --dark-blue: #1b1d21;
  --font-family: "Work Sans", sans-serif;
  --second-family: "Poppins", sans-serif;
  --third-family: "Lexend Tera", sans-serif;
  --font3: "Neue Machina", sans-serif;
}

.accent {
  color: #355e3b;
  color: var(--primary-green);
}

.bolt {
  font-weight: 800;
}

.is-scroll-disable {
  overflow: hidden;
}

.visually-hidden {
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
}

*,
*::after,
*::before {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: "Work Sans", sans-serif;
  font-family: var(--font-family);
  font-size: 14px;
  font-weight: 300;
  line-height: 1.5;
  margin: 0;
  color: #727272;
  color: var(--text-2);
  cursor: default;
  background-color: #f7f7f7;
  background-color: var(--primary);
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
  -o-object-fit: cover;
     object-fit: cover;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

a {
  display: inline-block;
}

address {
  font-style: normal;
}

main {
  position: relative;
}

.button {
  display: block;
  border-radius: 29px;
  padding: 4px 14px;
  color: #f4f4f4;
  color: var(--white);
  box-shadow: inset 3px 4px 4px 0 rgba(0, 0, 0, 0.25);
  background: #355e3b;
  background: var(--primary-green);
  border: 2px solid #355e3b;
  border: 2px solid var(--primary-green);
  cursor: pointer;
  font-weight: 600;
  text-wrap: nowrap;
}
.button:hover {
  color: #355e3b;
  color: var(--primary-green);
  background: transparent;
}
@media screen and (min-width: 768px) {
  .button {
    padding: 16px 32px;
  }
}

.calculator-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding-top: 40px;
}
.calculator-form__button {
  width: 50%;
  margin: 0 auto;
}

.input {
  position: relative;
}
.input__label {
  position: absolute;
  top: -30px;
  left: 42px;
}
.input__control {
  padding: 8px 24px;
  width: 100%;
  font-size: 16px;
  line-height: 1.17;
  border-radius: 8px;
  border: 1px solid #355e3b;
  border: 1px solid var(--primary-green);
  background-color: transparent;
}
.input__control:focus {
  border-color: #355e3b;
  border-color: var(--primary-green);
  outline: none;
}
.input__control::-moz-placeholder {
  color: #484848;
  color: var(--text-1);
  font-size: 16px;
  line-height: 1.17;
}
.input__control::placeholder {
  color: #484848;
  color: var(--text-1);
  font-size: 16px;
  line-height: 1.17;
}
.input__control:focus::-moz-placeholder {
  color: #727272;
  color: var(--text-2);
}
.input__control:focus::placeholder {
  color: #727272;
  color: var(--text-2);
}
@media screen and (min-width: 768px) {
  .input__control {
    padding: 16px 42px;
  }
}

.lifehack-item {
  background: #ffffff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  position: relative;
}
.lifehack-item__badge {
  position: absolute;
  top: -10px;
  left: 20px;
  background-color: #f3b86a;
  background-color: var(--secondary);
  color: #fff;
  font-size: 0.75rem;
  padding: 0.3rem 0.7rem;
  border-radius: 12px;
  text-transform: uppercase;
}
.lifehack-item__title {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
}
.lifehack-item__top {
  display: flex;
  gap: 1rem;
}
.lifehack-item__image {
  width: 24px;
  height: 24px;
}
.lifehack-item__text {
  font-size: 0.95rem;
  line-height: 1.5;
  color: #333;
}

.link {
  color: #484848;
  color: var(--text-1);
  text-decoration: none;
  transition: color 0.3s;
}
.link:hover {
  color: #355e3b;
  color: var(--primary-green);
}

.logo {
  gap: 5px;
  align-items: center;
  display: flex;
  font-weight: 800;
  font-size: 24px;
  text-wrap: nowrap;
}
@media screen and (min-width: 1000px) {
  .logo {
    font-size: 30px;
  }
}
.logo__link {
  color: #355e3b;
  color: var(--primary-green);
}
.logo__link:hover {
  color: #355e3b;
  color: var(--primary-green);
}
.logo__img {
  height: 24px;
  width: 24px;
}

.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
@media screen and (min-width: 1000px) {
  .pagination {
    display: none;
  }
}
.pagination__button {
  width: 12px;
  height: 12px;
  padding: 0;
  background-color: var(--text-color-primary);
  border-radius: 50%;
}
.pagination__button--active {
  background-color: var(--color-accent);
}

.policy {
  font-size: 24px;
  color: var(--color-text-secondary);
  margin: 20px;
}
.policy__title {
  text-align: center;
}

.tipps-card {
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
  gap: 10px;
}
.tipps-card__title {
  font-weight: 600;
  font-size: 18px;
  color: #484848;
  color: var(--text-1);
}
.tipps-card__text {
  font-weight: 400;
  font-size: 12px;
  line-height: 157%;
  color: #727272;
  color: var(--text-2);
}
.tipps-card__img {
  float: left;
  height: 16px;
  width: 16px;
}

.calculator-section {
  font-size: 18px;
}
.calculator-section__container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 25px;
}
@media screen and (min-width: 1000px) {
  .calculator-section__container {
    flex-direction: row;
  }
}
.calculator-section__paragraph {
  padding-top: 40px;
}
.calculator-section__container-text {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
@media screen and (min-width: 1000px) {
  .calculator-section__container-text {
    width: 50%;
  }
}
.calculator-section__container-form {
  width: 100%;
}
@media screen and (min-width: 1000px) {
  .calculator-section__container-form {
    width: 40%;
  }
}
.calculator-section__result {
  padding-top: 20px;
}

.contact-section {
  padding: 4rem 0;
  text-align: center;
}
.contact-section__subtitle {
  padding: 40px 0;
}
.contact-section__wrapper {
  width: 100%;
}
@media screen and (min-width: 768px) {
  .contact-section__wrapper {
    width: 50%;
    margin: 0 auto;
  }
}
.contact-section__contact-form {
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.contact-section__contact-form label {
  display: block;
  margin-bottom: 0.25rem;
  margin-left: 5px;
  font-weight: 500;
  text-align: left;
}
.contact-section__button {
  width: 50%;
  margin: 0 auto;
}

.container {
  width: 100%;
  max-width: 1288px;
  margin: 0 auto;
  padding: 0 24px;
}

.footer {
  padding: 32px 0;
  color: var(--color-white);
}
.footer__address-link {
  color: var(--color-white);
  font-size: 16px;
  font-weight: 300;
  text-decoration: none;
}
.footer__address-link:hover {
  color: var(--color-secondary);
}
.footer__info {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}
.footer__info:before {
  content: "";
  border: 1px solid #5F5F5F;
  width: 100%;
}
.footer__info-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding-top: 20px;
  gap: 20px;
}
@media screen and (min-width: 768px) {
  .footer__info-container {
    flex-direction: row;
  }
}
.footer__links {
  width: 60%;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}

.header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 10px 16px;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  background: #f4f4f4;
  background: var(--white);
  font-size: 14px;
  z-index: 2;
}
.header__container {
  display: flex;
  align-items: center;
  gap: 40px;
}
.header__nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  gap: 40px;
}
.header__menu {
  display: none;
}
@media screen and (min-width: 768px) {
  .header__menu {
    display: flex;
    justify-content: center;
    gap: 40px;
    margin-right: 60px;
    font-weight: 700;
    font-size: 15px;
  }
}
.header__burger {
  background-color: transparent;
  border: none;
  height: 24px;
  width: 24px;
  padding: 0;
  fill: #355e3b;
  fill: var(--primary-green);
}
@media screen and (min-width: 768px) {
  .header__burger {
    display: none;
  }
}
.header__button {
  display: none;
}
@media screen and (min-width: 1000px) {
  .header__button {
    display: block;
  }
}

.hero-section {
  padding: 104px 0;
  position: relative;
}
@media screen and (min-width: 768px) {
  .hero-section {
    padding: 124px 0;
  }
}
.hero-section__container {
  padding-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
.hero-section__title {
  font-family: "Lexend Tera", sans-serif;
  font-family: var(--third-family);
  font-weight: 800;
  font-size: 50px;
  text-transform: uppercase;
  color: #355e3b;
  color: var(--primary-green);
  margin-bottom: 42px;
}
@media screen and (min-width: 768px) {
  .hero-section__title {
    font-size: 45px;
  }
}
@media screen and (min-width: 1000px) {
  .hero-section__title {
    font-size: 55px;
  }
}
.hero-section__text {
  font-family: "Work Sans", sans-serif;
  font-family: var(--font-family);
  font-weight: 400;
  font-size: 16px;
  line-height: 137%;
  margin-bottom: 22px;
}
@media screen and (min-width: 768px) {
  .hero-section__text {
    font-size: 20px;
  }
}
@media screen and (min-width: 1000px) {
  .hero-section__text {
    font-size: 24px;
  }
}
.hero-section__button {
  width: 50%;
  margin: 0 auto;
}
@media screen and (min-width: 1000px) {
  .hero-section__button {
    display: none;
  }
}
.hero-section__img {
  display: none;
}
@media screen and (min-width: 768px) {
  .hero-section__img {
    width: 50%;
    display: block;
  }
}

.intro-section {
  padding-top: 40px;
  font-size: 16px;
}
@media screen and (min-width: 768px) {
  .intro-section {
    padding-top: 96px;
  }
}
@media screen and (min-width: 1000px) {
  .intro-section {
    font-size: 18px;
  }
}
.intro-section__container {
  padding-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}
.intro-section__content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.intro-section__title {
  margin-bottom: 42px;
}
.intro-section__text {
  width: 50%;
}
.intro-section__img {
  display: none;
}
@media screen and (min-width: 768px) {
  .intro-section__img {
    width: 50%;
    display: block;
  }
}

.lifehacks-section {
  padding: 4rem 0;
}
.lifehacks-section__list {
  padding-top: 40px;
  display: grid;
  grid-gap: 2rem;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
}

.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  width: 100%;
  height: 100%;
  padding: 16px 24px;
  background-color: #f7f7f7;
  background-color: var(--primary);
  transform: translateX(100%);
  transition: transform 0.3s;
}
.mobile-menu::after {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 180px;
  height: 240px;
  content: "";
}
.mobile-menu.is-open {
  transform: translateX(0);
}
.mobile-menu__btn-close {
  position: absolute;
  top: 16px;
  right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  fill: transparent;
  stroke: #355e3b;
  stroke: var(--primary-green);
  background-color: transparent;
  border: none;
  cursor: pointer;
}
.mobile-menu__logo {
  margin-bottom: 32px;
  gap: 5px;
  align-items: center;
  display: flex;
  font-weight: 800;
  font-size: 30px;
  color: #355e3b;
  color: var(--primary-green);
}
.mobile-menu__logo:hover {
  color: #355e3b;
  color: var(--primary-green);
}
.mobile-menu__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.mobile-menu__link {
  color: #484848;
  color: var(--text-1);
  font-size: 14px;
  line-height: 1.5;
  text-decoration: none;
}
.mobile-menu__link:hover {
  color: #355e3b;
  color: var(--primary-green);
}

.section {
  padding: 20px 0;
  font-family: "Lexend Tera", sans-serif;
  font-family: var(--third-family);
}
@media screen and (min-width: 768px) {
  .section {
    padding: 48px 0;
  }
}
.section__title {
  font-size: 32px;
  font-weight: 800;
  line-height: 1.5;
  text-transform: uppercase;
  color: #355e3b;
  color: var(--primary-green);
}
@media screen and (min-width: 768px) {
  .section__title {
    font-size: 64px;
    line-height: 1.3;
  }
}
.section__title--centered {
  text-align: center;
}
.section__line {
  width: 226px;
  background-image: linear-gradient(90deg, transparent, #5F5F5F, transparent);
  border: 0;
  height: 2px;
}

.terms {
  font-size: 18px;
  padding-top: 50px;
}
.terms__container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.terms__subtitle {
  font-size: 20px;
}

.testimonials-section {
  padding: 4rem 0;
  text-align: center;
}
.testimonials-section__title {
  margin-bottom: 0.5rem;
}
.testimonials-section__subtitle {
  padding-top: 40px;
  color: #666;
  font-size: 1rem;
  margin-bottom: 2rem;
}

.testimonials-list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  grid-gap: 2rem;
  gap: 2rem;
  margin-top: 2rem;
}

.testimonial-card {
  background-color: #fff;
  padding: 28px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 100px 30px 100px 30px;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);
  transition: transform 0.3s ease;
}
.testimonial-card:hover {
  transform: translateY(-5px);
}
.testimonial-card__image {
  height: 63px;
  width: 63px;
}
.testimonial-card__text {
  font-weight: 400;
  font-size: 14px;
  line-height: 157%;
  text-align: center;
  color: #727272;
  color: var(--text-2);
}
.testimonial-card__author {
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  text-align: center;
  color: #484848;
  color: var(--text-1);
}

.tipps-section__subtitle {
  font-weight: 700;
  padding-top: 40px;
  font-size: 28px;
  text-align: center;
}
.tipps-section__container {
  padding-top: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 50px;
  flex-direction: row-reverse;
}
.tipps-section__list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-top: 40px;
}
.tipps-section__img {
  display: none;
}
@media screen and (min-width: 768px) {
  .tipps-section__img {
    width: 40%;
    display: block;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/utils/_fonts.scss","webpack://./src/scss/styles.scss","webpack://./src/scss/utils/_variables.scss","webpack://./src/scss/utils/_utils.scss","webpack://./src/scss/_base.scss","webpack://./src/scss/components/_buttons.scss","webpack://./src/scss/components/_calculator-form.scss","webpack://./src/scss/components/_input.scss","webpack://./src/scss/components/_lifehack-item.scss","webpack://./src/scss/components/_link.scss","webpack://./src/scss/components/_logo.scss","webpack://./src/scss/components/_pagination.scss","webpack://./src/scss/components/_policy.scss","webpack://./src/scss/components/_tipps-card.scss","webpack://./src/scss/layouts/_calculator-section.scss","webpack://./src/scss/layouts/_contact-section.scss","webpack://./src/scss/layouts/_container.scss","webpack://./src/scss/layouts/_footer.scss","webpack://./src/scss/layouts/_header.scss","webpack://./src/scss/layouts/_hero-section.scss","webpack://./src/scss/layouts/_intro-section.scss","webpack://./src/scss/layouts/_lifehacks-section.scss","webpack://./src/scss/layouts/_mobile-menu.scss","webpack://./src/scss/layouts/_section.scss","webpack://./src/scss/layouts/_terms.scss","webpack://./src/scss/layouts/_testimonials-section.scss","webpack://./src/scss/layouts/_tipps-section.scss"],"names":[],"mappings":"AAAA,8BAAA;AACA;EACE,kBAAA,EAAA,sGAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA,EAAA,4DAAA;ACCF;ADCA,0BAAA;AACA;EACE,kBAAA,EAAA,sGAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA,EAAA,4DAAA;ACCF;ADCA,0BAAA;AACA;EACE,kBAAA,EAAA,sGAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA,EAAA,4DAAA;ACCF;ADCA,gCAAA;AACA;EACE,kBAAA,EAAA,sGAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA,EAAA,4DAAA;ACCF;ADCA,4BAAA;AACA;EACE,kBAAA,EAAA,sGAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4DAAA,EAAA,4DAAA;ACCF;ACvCA;EACE,kBAAA;EACA,wBAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EAEA,sCAAA;EACA,sCAAA;EACA,yCAAA;EACA,mCAAA;ADwCF;;AErDA;EACE,cAAA;EAAA,2BAAA;AFwDF;;AErDA;EACE,gBAAA;AFwDF;;AErDA;EACE,gBAAA;AFwDF;;AErDA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AFwDF;;AG1EA;;;EAGE,sBAAA;AH6EF;;AG1EA;EACE,uBAAA;AH6EF;;AG1EA;EACE,oCAAA;EAAA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;EAAA,oBAAA;EACA,eAAA;EACA,yBAAA;EAAA,gCAAA;AH6EF;;AG1EA;;;;;;;EAOE,SAAA;AH6EF;;AG1EA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,oBAAA;KAAA,iBAAA;AH6EF;;AG1EA;EACE,qBAAA;EACA,SAAA;EACA,UAAA;AH6EF;;AG1EA;EACE,qBAAA;AH6EF;;AG1EA;EACE,kBAAA;AH6EF;;AG1EA;EACE,kBAAA;AH6EF;;AIlIA;EACE,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EAAA,mBAAA;EACA,mDAAA;EACA,mBAAA;EAAA,gCAAA;EACA,yBAAA;EAAA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AJqIF;AInIE;EACE,cAAA;EAAA,2BAAA;EACA,uBAAA;AJqIJ;AIlIE;EAjBF;IAkBI,kBAAA;EJqIF;AACF;;AKxJA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AL2JF;AKzJE;EACE,UAAA;EACA,cAAA;AL2JJ;;AMpKA;EACE,kBAAA;ANuKF;AMrKE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;ANuKJ;AMpKE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EAAA,sCAAA;EACA,6BAAA;ANsKJ;AMpKI;EACE,qBAAA;EAAA,kCAAA;EACA,aAAA;ANsKN;AMnKI;EACE,cAAA;EAAA,oBAAA;EACA,eAAA;EACA,iBAAA;ANqKN;AMxKI;EACE,cAAA;EAAA,oBAAA;EACA,eAAA;EACA,iBAAA;ANqKN;AMlKI;EACE,cAAA;EAAA,oBAAA;ANoKN;AMrKI;EACE,cAAA;EAAA,oBAAA;ANoKN;AMjKI;EAxBF;IAyBI,kBAAA;ENoKJ;AACF;;AOvMA;EACE,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;AP0MF;AOxME;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,yBAAA;EAAA,kCAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,yBAAA;AP0MJ;AOvME;EACE,iBAAA;EACA,gBAAA;EACA,qBAAA;APyMJ;AOtME;EACE,aAAA;EACA,SAAA;APwMJ;AOrME;EACE,WAAA;EACA,YAAA;APuMJ;AOpME;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;APsMJ;;AQ5OA;EACE,cAAA;EAAA,oBAAA;EACA,qBAAA;EACA,sBAAA;AR+OF;AQ7OE;EACE,cAAA;EAAA,2BAAA;AR+OJ;;ASrPA;EACE,QAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;ATwPF;AStPE;EARF;IASI,eAAA;ETyPF;AACF;ASvPE;EACE,cAAA;EAAA,2BAAA;ATyPJ;ASvPI;EACE,cAAA;EAAA,2BAAA;ATyPN;ASrPE;EACE,YAAA;EACA,WAAA;ATuPJ;;AU7QA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;AVgRF;AU9QE;EANF;IAOI,aAAA;EViRF;AACF;AU/QE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,2CAAA;EACA,kBAAA;AViRJ;AU/QI;EACE,qCAAA;AViRN;;AWnSA;EACE,eAAA;EACA,kCAAA;EACA,YAAA;AXsSF;AWpSE;EACE,kBAAA;AXsSJ;;AY5SA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;AZ+SF;AY7SE;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,oBAAA;AZ+SJ;AY5SE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EAAA,oBAAA;AZ8SJ;AY3SE;EACE,WAAA;EACA,YAAA;EACA,WAAA;AZ6SJ;;AanUA;EACE,eAAA;AbsUF;AapUE;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AbsUJ;AapUI;EAPF;IAQI,mBAAA;EbuUJ;AACF;AapUE;EACE,iBAAA;AbsUJ;AanUE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AbqUJ;AanUI;EANF;IAOI,UAAA;EbsUJ;AACF;AanUE;EACE,WAAA;AbqUJ;AanUI;EAHF;IAII,UAAA;EbsUJ;AACF;AanUE;EACE,iBAAA;AbqUJ;;Ac5WA;EACE,eAAA;EACA,kBAAA;Ad+WF;Ac7WE;EACE,eAAA;Ad+WJ;Ac5WE;EACE,WAAA;Ad8WJ;Ac5WI;EAHF;IAII,UAAA;IACA,cAAA;Ed+WJ;AACF;Ac5WE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;Ad8WJ;Ac5WI;EACE,cAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;Ad8WN;Ac1WE;EACE,UAAA;EACA,cAAA;Ad4WJ;;Ae7YA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AfgZF;;AgBpZA;EACE,eAAA;EACA,yBAAA;AhBuZF;AgBrZE;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AhBuZJ;AgBpZE;EACE,6BAAA;AhBsZJ;AgBnZE;EACE,aAAA;EACA,sBAAA;EACA,eAAA;AhBqZJ;AgBnZI;EACE,WAAA;EACA,yBAAA;EACA,WAAA;AhBqZN;AgBjZE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,SAAA;AhBmZJ;AgBjZI;EARF;IASI,mBAAA;EhBoZJ;AACF;AgBjZE;EACE,UAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;AhBmZJ;;AiB/bA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,kBAAA;EACA,yCAAA;EACA,mBAAA;EAAA,wBAAA;EACA,eAAA;EACA,UAAA;AjBkcF;AiBhcE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AjBkcJ;AiB/bE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,SAAA;AjBicJ;AiB9bE;EACE,aAAA;AjBgcJ;AiB9bI;EAHF;IAII,aAAA;IACA,uBAAA;IACA,SAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;EjBicJ;AACF;AiB9bE;EACE,6BAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EAAA,0BAAA;AjBgcJ;AiB9bI;EARF;IASI,aAAA;EjBicJ;AACF;AiB9bE;EACE,aAAA;AjBgcJ;AiB9bI;EAHF;IAII,cAAA;EjBicJ;AACF;;AkBzfA;EACE,gBAAA;EACA,kBAAA;AlB4fF;AkB1fE;EAJF;IAKI,gBAAA;ElB6fF;AACF;AkB3fE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AlB6fJ;AkB1fE;EACE,sCAAA;EAAA,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EAAA,2BAAA;EACA,mBAAA;AlB4fJ;AkB1fI;EARF;IASI,eAAA;ElB6fJ;AACF;AkB3fI;EAZF;IAaI,eAAA;ElB8fJ;AACF;AkB3fE;EACE,oCAAA;EAAA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AlB6fJ;AkB3fI;EAPF;IAQI,eAAA;ElB8fJ;AACF;AkB5fI;EAXF;IAYI,eAAA;ElB+fJ;AACF;AkB5fE;EACE,UAAA;EACA,cAAA;AlB8fJ;AkB5fI;EAJF;IAKI,aAAA;ElB+fJ;AACF;AkB5fE;EACE,aAAA;AlB8fJ;AkB5fI;EAHF;IAII,UAAA;IACA,cAAA;ElB+fJ;AACF;;AmB/jBA;EACE,iBAAA;EACA,eAAA;AnBkkBF;AmBhkBE;EAJF;IAKI,iBAAA;EnBmkBF;AACF;AmBjkBE;EARF;IASI,eAAA;EnBokBF;AACF;AmBlkBE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AnBokBJ;AmBjkBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AnBmkBJ;AmBhkBE;EACE,mBAAA;AnBkkBJ;AmB/jBE;EACE,UAAA;AnBikBJ;AmB9jBE;EACE,aAAA;AnBgkBJ;AmB9jBI;EAHF;IAII,UAAA;IACA,cAAA;EnBikBJ;AACF;;AoBzmBA;EACE,eAAA;ApB4mBF;AoB1mBE;EACE,iBAAA;EACA,aAAA;EACA,cAAA;EAAA,SAAA;EACA,2DAAA;ApB4mBJ;;AqBnnBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EAAA,gCAAA;EACA,2BAAA;EACA,0BAAA;ArBsnBF;AqBpnBE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;ArBsnBJ;AqBnnBE;EACE,wBAAA;ArBqnBJ;AqBlnBE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;EAAA,4BAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;ArBonBJ;AqBjnBE;EACE,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EAAA,2BAAA;ArBmnBJ;AqBjnBI;EACE,cAAA;EAAA,2BAAA;ArBmnBN;AqB/mBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;ArBinBJ;AqB9mBE;EACE,cAAA;EAAA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;ArBgnBJ;AqB9mBI;EACE,cAAA;EAAA,2BAAA;ArBgnBN;;AsBnrBA;EACE,eAAA;EACA,sCAAA;EAAA,gCAAA;AtBsrBF;AsBprBE;EAJF;IAKI,eAAA;EtBurBF;AACF;AsBrrBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EAAA,2BAAA;AtBurBJ;AsBrrBI;EAPF;IAQI,eAAA;IACA,gBAAA;EtBwrBJ;AACF;AsBtrBI;EACE,kBAAA;AtBwrBN;AsBprBE;EACE,YAAA;EACA,2EAAA;EACA,SAAA;EACA,WAAA;AtBsrBJ;;AuBntBA;EACE,eAAA;EACA,iBAAA;AvBstBF;AuBptBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AvBstBJ;AuBntBE;EACE,eAAA;AvBqtBJ;;AwBhuBA;EACE,eAAA;EACA,kBAAA;AxBmuBF;AwBjuBE;EACE,qBAAA;AxBmuBJ;AwBhuBE;EACE,iBAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;AxBkuBJ;;AwB9tBA;EACE,aAAA;EACA,2DAAA;EACA,cAAA;EAAA,SAAA;EACA,gBAAA;AxBiuBF;;AwB9tBA;EACE,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0CAAA;EACA,+BAAA;AxBiuBF;AwB/tBE;EACE,2BAAA;AxBiuBJ;AwB9tBE;EACE,YAAA;EACA,WAAA;AxBguBJ;AwB7tBE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EAAA,oBAAA;AxB+tBJ;AwB5tBE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EAAA,oBAAA;AxB8tBJ;;AyBpxBE;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AzBuxBJ;AyBpxBE;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,2BAAA;AzBsxBJ;AyBnxBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AzBqxBJ;AyBlxBE;EACE,aAAA;AzBoxBJ;AyBlxBI;EAHF;IAII,UAAA;IACA,cAAA;EzBqxBJ;AACF","sourcesContent":["/* work-sans-regular - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../../public/fonts/work-sans-v19-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* work-sans-500 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 500;\n  src: url('../../public/fonts/work-sans-v19-latin-500.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* work-sans-700 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: 'Work Sans';\n  font-style: normal;\n  font-weight: 700;\n  src: url('../../public/fonts/work-sans-v19-latin-700.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* lexend-tera-regular - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: 'Lexend Tera';\n  font-style: normal;\n  font-weight: 400;\n  src: url('../../public/fonts/lexend-tera-v28-latin-regular.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* lexend-tera-800 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: 'Lexend Tera';\n  font-style: normal;\n  font-weight: 800;\n  src: url('../../public/fonts/lexend-tera-v28-latin-800.woff2') format('woff2'); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n","/* work-sans-regular - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Work Sans\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../../public/fonts/work-sans-v19-latin-regular.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* work-sans-500 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Work Sans\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"../../public/fonts/work-sans-v19-latin-500.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* work-sans-700 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Work Sans\";\n  font-style: normal;\n  font-weight: 700;\n  src: url(\"../../public/fonts/work-sans-v19-latin-700.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* lexend-tera-regular - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Lexend Tera\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../../public/fonts/lexend-tera-v28-latin-regular.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* lexend-tera-800 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Lexend Tera\";\n  font-style: normal;\n  font-weight: 800;\n  src: url(\"../../public/fonts/lexend-tera-v28-latin-800.woff2\") format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n:root {\n  --primary: #f7f7f7;\n  --primary-green: #355e3b;\n  --text-2: #727272;\n  --secondary: #f3b86a;\n  --text-1: #484848;\n  --white: #f4f4f4;\n  --white-main: #fefefe;\n  --dark-blue: #1b1d21;\n  --font-family: \"Work Sans\", sans-serif;\n  --second-family: \"Poppins\", sans-serif;\n  --third-family: \"Lexend Tera\", sans-serif;\n  --font3: \"Neue Machina\", sans-serif;\n}\n\n.accent {\n  color: var(--primary-green);\n}\n\n.bolt {\n  font-weight: 800;\n}\n\n.is-scroll-disable {\n  overflow: hidden;\n}\n\n.visually-hidden {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n\n*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin: 0;\n  color: var(--text-2);\n  cursor: default;\n  background-color: var(--primary);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\na {\n  display: inline-block;\n}\n\naddress {\n  font-style: normal;\n}\n\nmain {\n  position: relative;\n}\n\n.button {\n  display: block;\n  border-radius: 29px;\n  padding: 4px 14px;\n  color: var(--white);\n  box-shadow: inset 3px 4px 4px 0 rgba(0, 0, 0, 0.25);\n  background: var(--primary-green);\n  border: 2px solid var(--primary-green);\n  cursor: pointer;\n  font-weight: 600;\n  text-wrap: nowrap;\n}\n.button:hover {\n  color: var(--primary-green);\n  background: transparent;\n}\n@media screen and (min-width: 768px) {\n  .button {\n    padding: 16px 32px;\n  }\n}\n\n.calculator-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding-top: 40px;\n}\n.calculator-form__button {\n  width: 50%;\n  margin: 0 auto;\n}\n\n.input {\n  position: relative;\n}\n.input__label {\n  position: absolute;\n  top: -30px;\n  left: 42px;\n}\n.input__control {\n  padding: 8px 24px;\n  width: 100%;\n  font-size: 16px;\n  line-height: 1.17;\n  border-radius: 8px;\n  border: 1px solid var(--primary-green);\n  background-color: transparent;\n}\n.input__control:focus {\n  border-color: var(--primary-green);\n  outline: none;\n}\n.input__control::placeholder {\n  color: var(--text-1);\n  font-size: 16px;\n  line-height: 1.17;\n}\n.input__control:focus::placeholder {\n  color: var(--text-2);\n}\n@media screen and (min-width: 768px) {\n  .input__control {\n    padding: 16px 42px;\n  }\n}\n\n.lifehack-item {\n  background: #ffffff;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n.lifehack-item__badge {\n  position: absolute;\n  top: -10px;\n  left: 20px;\n  background-color: var(--secondary);\n  color: #fff;\n  font-size: 0.75rem;\n  padding: 0.3rem 0.7rem;\n  border-radius: 12px;\n  text-transform: uppercase;\n}\n.lifehack-item__title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n}\n.lifehack-item__top {\n  display: flex;\n  gap: 1rem;\n}\n.lifehack-item__image {\n  width: 24px;\n  height: 24px;\n}\n.lifehack-item__text {\n  font-size: 0.95rem;\n  line-height: 1.5;\n  color: #333;\n}\n\n.link {\n  color: var(--text-1);\n  text-decoration: none;\n  transition: color 0.3s;\n}\n.link:hover {\n  color: var(--primary-green);\n}\n\n.logo {\n  gap: 5px;\n  align-items: center;\n  display: flex;\n  font-weight: 800;\n  font-size: 24px;\n  text-wrap: nowrap;\n}\n@media screen and (min-width: 1000px) {\n  .logo {\n    font-size: 30px;\n  }\n}\n.logo__link {\n  color: var(--primary-green);\n}\n.logo__link:hover {\n  color: var(--primary-green);\n}\n.logo__img {\n  height: 24px;\n  width: 24px;\n}\n\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n}\n@media screen and (min-width: 1000px) {\n  .pagination {\n    display: none;\n  }\n}\n.pagination__button {\n  width: 12px;\n  height: 12px;\n  padding: 0;\n  background-color: var(--text-color-primary);\n  border-radius: 50%;\n}\n.pagination__button--active {\n  background-color: var(--color-accent);\n}\n\n.policy {\n  font-size: 24px;\n  color: var(--color-text-secondary);\n  margin: 20px;\n}\n.policy__title {\n  text-align: center;\n}\n\n.tipps-card {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 15px;\n  gap: 10px;\n}\n.tipps-card__title {\n  font-weight: 600;\n  font-size: 18px;\n  color: var(--text-1);\n}\n.tipps-card__text {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 157%;\n  color: var(--text-2);\n}\n.tipps-card__img {\n  float: left;\n  height: 16px;\n  width: 16px;\n}\n\n.calculator-section {\n  font-size: 18px;\n}\n.calculator-section__container {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  gap: 25px;\n}\n@media screen and (min-width: 1000px) {\n  .calculator-section__container {\n    flex-direction: row;\n  }\n}\n.calculator-section__paragraph {\n  padding-top: 40px;\n}\n.calculator-section__container-text {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n@media screen and (min-width: 1000px) {\n  .calculator-section__container-text {\n    width: 50%;\n  }\n}\n.calculator-section__container-form {\n  width: 100%;\n}\n@media screen and (min-width: 1000px) {\n  .calculator-section__container-form {\n    width: 40%;\n  }\n}\n.calculator-section__result {\n  padding-top: 20px;\n}\n\n.contact-section {\n  padding: 4rem 0;\n  text-align: center;\n}\n.contact-section__subtitle {\n  padding: 40px 0;\n}\n.contact-section__wrapper {\n  width: 100%;\n}\n@media screen and (min-width: 768px) {\n  .contact-section__wrapper {\n    width: 50%;\n    margin: 0 auto;\n  }\n}\n.contact-section__contact-form {\n  display: flex;\n  flex-direction: column;\n  gap: 28px;\n}\n.contact-section__contact-form label {\n  display: block;\n  margin-bottom: 0.25rem;\n  margin-left: 5px;\n  font-weight: 500;\n  text-align: left;\n}\n.contact-section__button {\n  width: 50%;\n  margin: 0 auto;\n}\n\n.container {\n  width: 100%;\n  max-width: 1288px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.footer {\n  padding: 32px 0;\n  color: var(--color-white);\n}\n.footer__address-link {\n  color: var(--color-white);\n  font-size: 16px;\n  font-weight: 300;\n  text-decoration: none;\n}\n.footer__address-link:hover {\n  color: var(--color-secondary);\n}\n.footer__info {\n  display: flex;\n  flex-direction: column;\n  padding: 20px 0;\n}\n.footer__info:before {\n  content: \"\";\n  border: 1px solid #5F5F5F;\n  width: 100%;\n}\n.footer__info-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-around;\n  padding-top: 20px;\n  gap: 20px;\n}\n@media screen and (min-width: 768px) {\n  .footer__info-container {\n    flex-direction: row;\n  }\n}\n.footer__links {\n  width: 60%;\n  justify-content: space-between;\n  display: flex;\n  flex-direction: row;\n}\n\n.header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px 16px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n  background: var(--white);\n  font-size: 14px;\n  z-index: 2;\n}\n.header__container {\n  display: flex;\n  align-items: center;\n  gap: 40px;\n}\n.header__nav {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-grow: 1;\n  gap: 40px;\n}\n.header__menu {\n  display: none;\n}\n@media screen and (min-width: 768px) {\n  .header__menu {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n    margin-right: 60px;\n    font-weight: 700;\n    font-size: 15px;\n  }\n}\n.header__burger {\n  background-color: transparent;\n  border: none;\n  height: 24px;\n  width: 24px;\n  padding: 0;\n  fill: var(--primary-green);\n}\n@media screen and (min-width: 768px) {\n  .header__burger {\n    display: none;\n  }\n}\n.header__button {\n  display: none;\n}\n@media screen and (min-width: 1000px) {\n  .header__button {\n    display: block;\n  }\n}\n\n.hero-section {\n  padding: 104px 0;\n  position: relative;\n}\n@media screen and (min-width: 768px) {\n  .hero-section {\n    padding: 124px 0;\n  }\n}\n.hero-section__container {\n  padding-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n}\n.hero-section__title {\n  font-family: var(--third-family);\n  font-weight: 800;\n  font-size: 50px;\n  text-transform: uppercase;\n  color: var(--primary-green);\n  margin-bottom: 42px;\n}\n@media screen and (min-width: 768px) {\n  .hero-section__title {\n    font-size: 45px;\n  }\n}\n@media screen and (min-width: 1000px) {\n  .hero-section__title {\n    font-size: 55px;\n  }\n}\n.hero-section__text {\n  font-family: var(--font-family);\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 137%;\n  margin-bottom: 22px;\n}\n@media screen and (min-width: 768px) {\n  .hero-section__text {\n    font-size: 20px;\n  }\n}\n@media screen and (min-width: 1000px) {\n  .hero-section__text {\n    font-size: 24px;\n  }\n}\n.hero-section__button {\n  width: 50%;\n  margin: 0 auto;\n}\n@media screen and (min-width: 1000px) {\n  .hero-section__button {\n    display: none;\n  }\n}\n.hero-section__img {\n  display: none;\n}\n@media screen and (min-width: 768px) {\n  .hero-section__img {\n    width: 50%;\n    display: block;\n  }\n}\n\n.intro-section {\n  padding-top: 40px;\n  font-size: 16px;\n}\n@media screen and (min-width: 768px) {\n  .intro-section {\n    padding-top: 96px;\n  }\n}\n@media screen and (min-width: 1000px) {\n  .intro-section {\n    font-size: 18px;\n  }\n}\n.intro-section__container {\n  padding-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 40px;\n}\n.intro-section__content {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n.intro-section__title {\n  margin-bottom: 42px;\n}\n.intro-section__text {\n  width: 50%;\n}\n.intro-section__img {\n  display: none;\n}\n@media screen and (min-width: 768px) {\n  .intro-section__img {\n    width: 50%;\n    display: block;\n  }\n}\n\n.lifehacks-section {\n  padding: 4rem 0;\n}\n.lifehacks-section__list {\n  padding-top: 40px;\n  display: grid;\n  gap: 2rem;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n}\n\n.mobile-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 20;\n  width: 100%;\n  height: 100%;\n  padding: 16px 24px;\n  background-color: var(--primary);\n  transform: translateX(100%);\n  transition: transform 0.3s;\n}\n.mobile-menu::after {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 180px;\n  height: 240px;\n  content: \"\";\n}\n.mobile-menu.is-open {\n  transform: translateX(0);\n}\n.mobile-menu__btn-close {\n  position: absolute;\n  top: 16px;\n  right: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  fill: transparent;\n  stroke: var(--primary-green);\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n.mobile-menu__logo {\n  margin-bottom: 32px;\n  gap: 5px;\n  align-items: center;\n  display: flex;\n  font-weight: 800;\n  font-size: 30px;\n  color: var(--primary-green);\n}\n.mobile-menu__logo:hover {\n  color: var(--primary-green);\n}\n.mobile-menu__list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.mobile-menu__link {\n  color: var(--text-1);\n  font-size: 14px;\n  line-height: 1.5;\n  text-decoration: none;\n}\n.mobile-menu__link:hover {\n  color: var(--primary-green);\n}\n\n.section {\n  padding: 20px 0;\n  font-family: var(--third-family);\n}\n@media screen and (min-width: 768px) {\n  .section {\n    padding: 48px 0;\n  }\n}\n.section__title {\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 1.5;\n  text-transform: uppercase;\n  color: var(--primary-green);\n}\n@media screen and (min-width: 768px) {\n  .section__title {\n    font-size: 64px;\n    line-height: 1.3;\n  }\n}\n.section__title--centered {\n  text-align: center;\n}\n.section__line {\n  width: 226px;\n  background-image: linear-gradient(90deg, transparent, #5F5F5F, transparent);\n  border: 0;\n  height: 2px;\n}\n\n.terms {\n  font-size: 18px;\n  padding-top: 50px;\n}\n.terms__container {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n.terms__subtitle {\n  font-size: 20px;\n}\n\n.testimonials-section {\n  padding: 4rem 0;\n  text-align: center;\n}\n.testimonials-section__title {\n  margin-bottom: 0.5rem;\n}\n.testimonials-section__subtitle {\n  padding-top: 40px;\n  color: #666;\n  font-size: 1rem;\n  margin-bottom: 2rem;\n}\n\n.testimonials-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.testimonial-card {\n  background-color: #fff;\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 100px 30px 100px 30px;\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);\n  transition: transform 0.3s ease;\n}\n.testimonial-card:hover {\n  transform: translateY(-5px);\n}\n.testimonial-card__image {\n  height: 63px;\n  width: 63px;\n}\n.testimonial-card__text {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 157%;\n  text-align: center;\n  color: var(--text-2);\n}\n.testimonial-card__author {\n  font-style: italic;\n  font-weight: 500;\n  font-size: 20px;\n  text-align: center;\n  color: var(--text-1);\n}\n\n.tipps-section__subtitle {\n  font-weight: 700;\n  padding-top: 40px;\n  font-size: 28px;\n  text-align: center;\n}\n.tipps-section__container {\n  padding-top: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 50px;\n  flex-direction: row-reverse;\n}\n.tipps-section__list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding-top: 40px;\n}\n.tipps-section__img {\n  display: none;\n}\n@media screen and (min-width: 768px) {\n  .tipps-section__img {\n    width: 40%;\n    display: block;\n  }\n}",":root {\n  --primary: #f7f7f7;;\n  --primary-green: #355e3b;\n  --text-2: #727272;\n  --secondary: #f3b86a;\n  --text-1: #484848;\n  --white: #f4f4f4;\n  --white-main: #fefefe;\n  --dark-blue: #1b1d21;\n\n  --font-family: \"Work Sans\", sans-serif;\n  --second-family: \"Poppins\", sans-serif;\n  --third-family: \"Lexend Tera\", sans-serif;\n  --font3: \"Neue Machina\", sans-serif;\n}\n\n$bp-desktop: 1000px;\n$bp-tablet: 768px;\n\n",".accent{\n  color: var(--primary-green);\n}\n\n.bolt {\n  font-weight: 800;\n}\n\n.is-scroll-disable {\n  overflow: hidden;\n}\n\n.visually-hidden {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n}\n","*,\n*::after,\n*::before {\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family: var(--font-family);\n  font-size: 14px;\n  font-weight: 300;\n  line-height: 1.5;\n  margin: 0;\n  color: var(--text-2);\n  cursor: default;\n  background-color: var(--primary);\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\np {\n  margin: 0;\n}\n\nimg {\n  display: block;\n  max-width: 100%;\n  height: auto;\n  object-fit: cover;\n}\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\na {\n  display: inline-block;\n}\n\naddress {\n  font-style: normal;\n}\n\nmain {\n  position: relative;\n}\n",".button {\n  display: block;\n  border-radius: 29px;\n  padding: 4px 14px;\n  color: var(--white);\n  box-shadow: inset 3px 4px 4px 0 rgba(0, 0, 0, 0.25);\n  background: var(--primary-green);\n  border: 2px solid var(--primary-green);\n  cursor: pointer;\n  font-weight: 600;\n  text-wrap: nowrap;\n\n  &:hover {\n    color: var(--primary-green);\n    background: transparent;\n  }\n\n  @media screen and (min-width: $bp-tablet) {\n    padding: 16px 32px;\n  }\n}\n",".calculator-form {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding-top: 40px;\n\n  &__button {\n    width: 50%;\n    margin: 0 auto;\n  }\n}\n",".input {\n  position: relative;\n\n  &__label {\n    position: absolute;\n    top: -30px;\n    left: 42px;\n  }\n\n  &__control {\n    padding: 8px 24px;\n    width: 100%;\n    font-size: 16px;\n    line-height: 1.17;\n    border-radius: 8px;\n    border: 1px solid var(--primary-green);\n    background-color: transparent;\n\n    &:focus {\n      border-color: var(--primary-green);\n      outline: none;\n    }\n\n    &::placeholder {\n      color: var(--text-1);\n      font-size: 16px;\n      line-height: 1.17;\n    }\n\n    &:focus::placeholder {\n      color: var(--text-2);\n    }\n\n    @media screen and (min-width: $bp-tablet) {\n      padding: 16px 42px;\n    }\n  }\n}\n",".lifehack-item {\n  background: #ffffff;\n  padding: 1.5rem;\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n  position: relative;\n\n  &__badge {\n    position: absolute;\n    top: -10px;\n    left: 20px;\n    background-color: var(--secondary);\n    color: #fff;\n    font-size: 0.75rem;\n    padding: 0.3rem 0.7rem;\n    border-radius: 12px;\n    text-transform: uppercase;\n  }\n\n  &__title {\n    font-size: 1.1rem;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n  }\n\n  &__top {\n    display: flex;\n    gap: 1rem;\n  }\n\n  &__image {\n    width: 24px;\n    height: 24px;\n  }\n\n  &__text {\n    font-size: 0.95rem;\n    line-height: 1.5;\n    color: #333;\n  }\n}\n",".link {\n  color: var(--text-1);\n  text-decoration: none;\n  transition: color 0.3s;\n\n  &:hover {\n    color: var(--primary-green);\n  }\n}\n",".logo {\n  gap: 5px;\n  align-items: center;\n  display: flex;\n  font-weight: 800;\n  font-size: 24px;\n  text-wrap: nowrap;\n\n  @media screen and (min-width: $bp-desktop) {\n    font-size: 30px;\n  }\n\n  &__link {\n    color: var(--primary-green);\n\n    &:hover {\n      color: var(--primary-green);\n    }\n  }\n\n  &__img {\n    height: 24px;\n    width: 24px;\n  }\n}\n",".pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 24px;\n\n  @media screen and (min-width: $bp-desktop) {\n    display: none;\n  }\n\n  &__button {\n    width: 12px;\n    height: 12px;\n    padding: 0;\n    background-color: var(--text-color-primary);\n    border-radius: 50%;\n\n    &--active {\n      background-color: var(--color-accent);\n    }\n  }\n}\n",".policy {\n  font-size: 24px;\n  color: var(--color-text-secondary);\n  margin: 20px;\n\n  &__title {\n    text-align: center;\n  }\n}\n",".tipps-card {\n  display: flex;\n  flex-direction: column;\n  padding-bottom: 15px;\n  gap: 10px;\n\n  &__title {\n    font-weight: 600;\n    font-size: 18px;\n    color: var(--text-1);\n  }\n\n  &__text {\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 157%;\n    color: var(--text-2);\n  }\n\n  &__img {\n    float:left;\n    height: 16px;\n    width: 16px;\n  }\n}\n",".calculator-section {\n  font-size: 18px;\n\n  &__container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    gap: 25px;\n\n    @media screen and (min-width: $bp-desktop) {\n      flex-direction: row;\n    }\n  }\n\n  &__paragraph {\n    padding-top: 40px;\n  }\n\n  &__container-text {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n\n    @media screen and (min-width: $bp-desktop) {\n      width: 50%;\n    }\n  }\n\n  &__container-form {\n    width: 100%;\n\n    @media screen and (min-width: $bp-desktop) {\n      width: 40%;\n    }\n  }\n\n  &__result {\n    padding-top: 20px;\n  }\n}\n",".contact-section {\n  padding: 4rem 0;\n  text-align: center;\n\n  &__subtitle {\n    padding: 40px 0;\n  }\n\n  &__wrapper {\n    width: 100%;\n\n    @media screen and (min-width: $bp-tablet) {\n      width: 50%;\n      margin: 0 auto;\n    }\n  }\n\n  &__contact-form {\n    display: flex;\n    flex-direction: column;\n    gap: 28px;\n\n    label {\n      display: block;\n      margin-bottom: 0.25rem;\n      margin-left: 5px;\n      font-weight: 500;\n      text-align: left;\n    }\n  }\n\n  &__button {\n    width: 50%;\n    margin: 0 auto;\n  }\n}\n\n",".container {\n  width: 100%;\n  max-width: 1288px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n",".footer {\n  padding: 32px 0;\n  color: var(--color-white);\n\n  &__address-link {\n    color: var(--color-white);\n    font-size: 16px;\n    font-weight: 300;\n    text-decoration: none;\n  }\n\n  &__address-link:hover {\n    color: var(--color-secondary);\n  }\n\n  &__info {\n    display: flex;\n    flex-direction: column;\n    padding: 20px 0;\n\n    &:before {\n      content: '';\n      border: 1px solid #5F5F5F;\n      width: 100%;\n    }\n  }\n\n  &__info-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-around;\n    padding-top: 20px;\n    gap: 20px;\n\n    @media screen and (min-width: $bp-tablet) {\n      flex-direction: row;\n    }\n  }\n\n  &__links {\n    width: 60%;\n    justify-content: space-between;\n    display: flex;\n    flex-direction: row;\n  }\n}\n",".header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  padding: 10px 16px;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);\n  background: var(--white);\n  font-size: 14px;\n  z-index: 2;\n\n  &__container {\n    display: flex;\n    align-items: center;\n    gap: 40px;\n  }\n\n  &__nav {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-grow: 1;\n    gap: 40px;\n  }\n\n  &__menu {\n    display: none;\n\n    @media screen and (min-width: $bp-tablet) {\n      display: flex;\n      justify-content: center;\n      gap: 40px;\n      margin-right: 60px;\n      font-weight: 700;\n      font-size: 15px;\n    }\n  }\n\n  &__burger {\n    background-color: transparent;\n    border: none;\n    height: 24px;\n    width: 24px;\n    padding: 0;\n    fill: var(--primary-green);\n\n    @media screen and (min-width: $bp-tablet) {\n      display: none;\n    }\n  }\n\n  &__button {\n    display: none;\n\n    @media screen and (min-width: $bp-desktop) {\n      display: block;\n    }\n  }\n}\n",".hero-section {\n  padding: 104px 0;\n  position: relative;\n\n  @media screen and (min-width: $bp-tablet) {\n    padding: 124px 0;\n  }\n\n  &__container {\n    padding-top: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 40px;\n  }\n\n  &__title {\n    font-family: var(--third-family);\n    font-weight: 800;\n    font-size: 50px;\n    text-transform: uppercase;\n    color: var(--primary-green);\n    margin-bottom: 42px;\n\n    @media screen and (min-width: $bp-tablet) {\n      font-size: 45px;\n    }\n\n    @media screen and (min-width: $bp-desktop) {\n      font-size: 55px;\n    }\n  }\n\n  &__text {\n    font-family: var(--font-family);\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 137%;\n    margin-bottom: 22px;\n\n    @media screen and (min-width: $bp-tablet) {\n      font-size: 20px;\n    }\n\n    @media screen and (min-width: $bp-desktop) {\n      font-size: 24px;\n    }\n  }\n\n  &__button {\n    width: 50%;\n    margin: 0 auto;\n\n    @media screen and (min-width: $bp-desktop) {\n      display: none;\n    }\n  }\n\n  &__img {\n    display: none;\n\n    @media screen and (min-width: $bp-tablet){\n      width: 50%;\n      display: block;\n    }\n  }\n}\n",".intro-section {\n  padding-top: 40px;\n  font-size: 16px;\n\n  @media screen and (min-width: $bp-tablet){\n    padding-top: 96px;\n  }\n\n  @media screen and (min-width: $bp-desktop){\n    font-size: 18px;\n  }\n\n  &__container {\n    padding-top: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 40px;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  &__title {\n    margin-bottom: 42px;\n  }\n\n  &__text {\n    width: 50%;\n  }\n\n  &__img {\n    display: none;\n\n    @media screen and (min-width: $bp-tablet){\n      width: 50%;\n      display: block;\n    }\n  }\n}\n",".lifehacks-section {\n  padding: 4rem 0;\n\n  &__list {\n    padding-top: 40px;\n    display: grid;\n    gap: 2rem;\n    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  }\n}\n",".mobile-menu {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 20;\n  width: 100%;\n  height: 100%;\n  padding: 16px 24px;\n  background-color: var(--primary);\n  transform: translateX(100%);\n  transition: transform .3s;\n\n  &::after {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 180px;\n    height: 240px;\n    content: '';\n  }\n\n  &.is-open {\n    transform: translateX(0);\n  }\n\n  &__btn-close {\n    position: absolute;\n    top: 16px;\n    right: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    fill: transparent;\n    stroke: var(--primary-green);\n    background-color: transparent;\n    border: none;\n    cursor: pointer;\n  }\n\n  &__logo {\n    margin-bottom: 32px;\n    gap: 5px;\n    align-items: center;\n    display: flex;\n    font-weight: 800;\n    font-size: 30px;\n    color: var(--primary-green);\n\n    &:hover {\n      color: var(--primary-green);\n    }\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n  }\n\n  &__link {\n    color: var(--text-1);\n    font-size: 14px;\n    line-height: 1.5;\n    text-decoration: none;\n\n    &:hover {\n      color: var(--primary-green);\n    }\n  }\n}\n",".section {\n  padding: 20px 0;\n  font-family: var(--third-family);\n\n  @media screen and (min-width: $bp-tablet) {\n    padding: 48px 0;\n  }\n\n  &__title {\n    font-size: 32px;\n    font-weight: 800;\n    line-height: 1.5;\n    text-transform: uppercase;\n    color: var(--primary-green);\n\n    @media screen and (min-width: $bp-tablet) {\n      font-size: 64px;\n      line-height: 1.3;\n    }\n\n    &--centered {\n      text-align: center;\n    }\n  }\n\n  &__line {\n    width: 226px;\n    background-image: linear-gradient(90deg, transparent, #5F5F5F, transparent);\n    border: 0;\n    height: 2px;\n  }\n}\n",".terms {\n  font-size: 18px;\n  padding-top: 50px;\n\n  &__container {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  &__subtitle {\n    font-size: 20px;\n  }\n}\n",".testimonials-section {\n  padding: 4rem 0;\n  text-align: center;\n\n  &__title {\n    margin-bottom: 0.5rem;\n  }\n\n  &__subtitle {\n    padding-top: 40px;\n    color: #666;\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n}\n\n.testimonials-list {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.testimonial-card {\n  background-color: #fff;\n  padding: 28px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 100px 30px 100px 30px;\n  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);\n  transition: transform 0.3s ease;\n\n  &:hover {\n    transform: translateY(-5px);\n  }\n\n  &__image {\n    height: 63px;\n    width: 63px;\n  }\n\n  &__text {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 157%;\n    text-align: center;\n    color: var(--text-2);\n  }\n\n  &__author {\n    font-style: italic;\n    font-weight: 500;\n    font-size: 20px;\n    text-align: center;\n    color: var(--text-1);\n  }\n}\n",".tipps-section {\n  &__subtitle {\n    font-weight: 700;\n    padding-top: 40px;\n    font-size: 28px;\n    text-align: center;\n  }\n\n  &__container {\n    padding-top: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 50px;\n    flex-direction: row-reverse;\n  }\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding-top: 40px;\n  }\n\n  &__img {\n    display: none;\n\n    @media screen and (min-width: $bp-tablet){\n      width: 40%;\n      display: block;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
